export default angular
  .module("CodeSystemOIDsCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("CodeSystemOIDsController", [
    "$scope",
    "$stateParams",
    "modal",
    "System",
    function (
      $scope,
      $stateParams,
      modal,
      System,
    ) {
      $scope.searchString = "";
      $scope.sortOIDs = {
        column: "CODE_SYSSTEM",
        direction: false,
      };
      $scope.loadingOIDs = false;
      $scope.supportedCountries = [];

      const codeSystemId = $stateParams.id;

      const loadCodeSystemOID = function (id) {
        if (id) {
          $scope.loadingOIDs = true;
          System.loadCodeSystemOIDs(id, (codeSystemOIDs) => {
            System.loadCountries((data) => {
              $scope.supportedCountries = data;
              $scope.supportedCountries.push({ ID: -1, NAME: "All" });

              $scope.codeSystem.OIDS = codeSystemOIDs;

              $scope.codeSystem.OIDS.forEach((OID) => {
                if (OID.ALL_NATIONS === 1) {
                  OID.NATIONS = [$scope.supportedCountries[$scope.supportedCountries.length - 1]];
                } else {
                  OID.NATIONS = OID.NATIONS.map(n =>
                    $scope.supportedCountries.find(c => c.ID === n));
                }
              });

              $scope.loadingOIDs = false;
            });
          });
        }
      };

      $scope.changeSorting = function (column) {
        if ($scope.sortOIDs.column === column) {
          $scope.sortOIDs.direction = !$scope.sortOIDs.direction;
        } else {
          $scope.sortOIDs.column = column;
          $scope.sortOIDs.direction = false;
        }
      };

      $scope.suggestCountries = function (query) {
        return $scope.supportedCountries.filter(country => (
          country.NAME.toLowerCase().indexOf(query.toLowerCase()) !== -1
        ));
      };

      $scope.getCountrySummary = function (selectedCountries) {
        return selectedCountries && selectedCountries.length > 0 ? selectedCountries.map(c => c.NAME).join(", ") : "None";
      };

      $scope.saveCodeSystemOID = (oid) => {
        const allNations = oid.NATIONS.find(g => g.ID === -1);

        oid.ALL_NATIONS = allNations ? 1 : 0;
        oid.NATIONS = allNations
          ? oid.NATIONS.filter(n => n.ID === -1)
          : oid.NATIONS;

        System.saveOID(oid, () => {
          loadCodeSystemOID(codeSystemId);
        });
      };

      $scope.removeCodeSystemOID = (oid) => {
        modal.openDelete(oid.ID, "OID").result.then(() => {
          System.deleteOID(oid, () => {
            loadCodeSystemOID(codeSystemId);
          });
        });
      };

      $scope.addNewCodeSystemOID = (searchString) => {
        const newOID = {
          OID: searchString.$,
          CODE_SYSTEM_ID: $scope.codeSystem.ID,
        };
        System.addNewCodeSystemOID(newOID, () => {
          loadCodeSystemOID(codeSystemId);
        });
      };

      loadCodeSystemOID(codeSystemId);
    },
  ]);
